import { render, staticRenderFns } from "./Midi.vue?vue&type=template&id=6974109f&scoped=true&"
import script from "./Midi.vue?vue&type=script&lang=js&"
export * from "./Midi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6974109f",
  null
  
)

export default component.exports